import { Link } from "react-router-dom";

import { StoreBadges } from "@/components/shared/StoreBadges";
import type { StoreLinkSurface } from "@/lib/storeLinks";
import { LOGIN } from "@/routes";
import { trackMarketingCtaClick, type MarketingCtaPlacement } from "@/services/marketingCtaAnalytics.service";

/**
 * Desktop-only web start beside the store badges. Mobile stays badge-first.
 * Label source: docs/content/published/website/copy.md.
 */
export const GetStartedLink = ({ surface, placement }: { surface: StoreLinkSurface; placement: MarketingCtaPlacement }) => {
  const loginHref = LOGIN();

  return (
    <Link
      to={loginHref}
      onClick={() =>
        trackMarketingCtaClick({
          destination: "signup_login",
          surface,
          placement,
          label: "Get started",
          href: loginHref,
        })
      }
      className="hidden self-stretch items-center rounded-full border border-foreground bg-foreground px-6 text-base font-semibold text-background md:inline-flex"
    >
      Get started
    </Link>
  );
};

/**
 * Closing CTA block for marketing/content pages.
 * Copy source: docs/content/published/website/copy.md (Final CTA section).
 */
export const GetStashtCta = ({
  surface,
  headline,
  showWebStart = false,
}: {
  surface: StoreLinkSurface;
  headline?: string;
  /** Adds the desktop-only Get started link beside the badges. */
  showWebStart?: boolean;
}) => (
  <section className="w-full rounded-2xl border border-foreground/10 bg-foreground/[0.03] px-6 py-8 md:px-10 md:py-10 flex flex-col items-center gap-4 text-center">
    <h2 className="text-2xl md:text-3xl font-semibold text-foreground leading-tight m-0">
      {headline ?? (
        <>
          Start Making Your <span className="whitespace-nowrap text-brand-500">Saves Worth It</span>
        </>
      )}
    </h2>
    <p className="text-foreground/70 m-0">Free on iOS, Android, and desktop.</p>
    <div className="flex items-center gap-4 mt-1">
      <StoreBadges className="h-12" surface={surface} placement="final_cta" />
      {showWebStart && <GetStartedLink surface={surface} placement="final_cta" />}
    </div>
  </section>
);
